import __request__ from 'routing/request';
interface SymantecEDRRequestImpl {
    readonly management_ip: string;
    readonly client_secret: unknown;
    readonly client_id: string;
}
interface SymantecEDRCreateInputRequest {
    readonly disable_tls_check: boolean;
    readonly polling_time_unit: 'NANOSECONDS' | 'MICROSECONDS' | 'MILLISECONDS' | 'SECONDS' | 'MINUTES' | 'HOURS' | 'DAYS';
    readonly content_type: string[];
    readonly management_ip: string;
    readonly name: string;
    readonly client_secret: unknown;
    readonly enable_throttling: boolean;
    readonly polling_interval: number;
    readonly client_id: string;
}
interface MediaType {
    readonly wildcard_subtype: boolean;
    readonly subtype: string;
    readonly wildcard_type: boolean;
    readonly type: string;
    readonly parameters: {
        readonly [_key: string]: string;
    };
}
/**
 * Validate API Credentials
 */
export function checkCredentials(JSONbody: SymantecEDRRequestImpl): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.symantecedr.api.SymantecEDRResource/symantecedr/checkCredentials', JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Create a new Symantec EDR input
 */
export function create(JSONbody: SymantecEDRCreateInputRequest, setup_wizard: boolean = false): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.symantecedr.api.SymantecEDRResource/symantecedr/inputs', JSONbody, { 'setup_wizard': setup_wizard }, {
        'Accept': ['application/json']
    });
}
